export const ODS_MODAL_ID = 'modalIdOdsZava'
